import { render, staticRenderFns } from "./CrMenuList.vue?vue&type=template&id=553091bb"
import script from "./CrMenuList.vue?vue&type=script&lang=js"
export * from "./CrMenuList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports